/**
 * Created by tom on 2016. 9. 2..
 */

axboot.addressPopup = {
    open: function open(cb) {
        //alert("open");
        var modalConfig = {
            width: 500,
            height: 600,
            iframe: {
                url: "/html/common/zipcode.html"
            },
            header: {
                title: "우편번호 찾기"
            },
            callback: cb
        };
        axboot.modal.open(modalConfig);
    },
    close: function close() {
        axboot.modal.close();
    }
};

//############################################################################################
//# axboot.util
//############################################################################################

axboot.util = (function(){
    var setSelectionRange = function (input, pos) {
        if (typeof pos == "undefined") {
            pos = input.value.length;
        }
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(pos, pos);
        }
        else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
        else if (input.selectionStart) {
            input.focus();
            input.selectionStart = pos;
            input.selectionEnd = pos;
        }
    };

    // form 의 input box 를 파라미터 맵으로 반환합니다.
    var getFormToParam = function ($form) {
        var param = {};

        if ($form) {
            var aryParam = $form.serializeArray();

            $.each(aryParam, function () {
                if (param[this.name]) {
                    if (!param[this.name].push) {
                        param[this.name] = [param[this.name]];
                    }
                    param[this.name].push(this.value || '');
                } else {
                    param[this.name] = this.value || '';
                }
            });
        }

        return param;
    };

    var getBindingTargets = function (obj) {
        var aryBindingTarget = [];

        if (ax5.util.isNothing(obj) || !obj.data) {
            return aryBindingTarget;
        }

        var bindingTarget = obj.data('bindingTarget');

        // 바인딩 타겟 존제 유무
        if (!ax5.util.isNothing(bindingTarget)) {
            if (bindingTarget.startsWith('[') && bindingTarget.endsWith(']')) {
                aryBindingTarget = ax5.util.parseJson(bindingTarget);
            } else {
                aryBindingTarget.push(bindingTarget);
            }
        }

        return aryBindingTarget;
    };

    var getObjectType = function (obj) {
        var objectType;

        if (obj.hasOwnProperty('name') && obj.name.toUpperCase() == 'GRID') {
            objectType = 'GRID';
        } else if (obj.hasOwnProperty('name') && obj.name.toUpperCase() == 'UPLOADER') {
            objectType = 'UPLOADER';
        } else if (obj.hasOwnProperty('target') && obj.target.length > 0 && obj.target[0].tagName.toUpperCase() === 'FORM') {
            objectType = 'FORM';
        }

        return objectType;
    };

    var getCommandOptionsToAjaxConfig = function (options) {
        var tempData = {};
        var ajaxConfig = {};

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            if (!ax5.util.isNothing(options.data)) {
                if (ax5.util.getType(options.data) === 'array') {
                    for (var i = 0; i < options.data.length; i++) {
                        tempData = $.extend(true, tempData, options.data[i]);
                    }
                } else if (ax5.util.getType(options.data) === 'object') {
                    tempData = $.extend(true, tempData, options.data);
                }
            }

            options.data = {};

            ajaxConfig['data'] = $.extend(true, {}, tempData);
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        return ajaxConfig;
    };

    // 그리드의 행 상태값을 반환합니다.
    var getRowState = function (data) {
        var rowState = '';

        if (data['__created__'] && data['__modified__']) {
            rowState = 'I';
        } else if (!data['__created__'] && data['__modified__']) {
            rowState = 'U';
        } else if (data['__selected__']) {
            rowState = 'R';
        } else {
            rowState = '';
        }

        return rowState;
    }

    // 그리드의 행이 선택되어있는지 확인합니다.
    var isSelectedRow = function (data) {
        if (data['__selected__']) {
            return true;
        }

        return false;
    }

    var isSaveRow = function (data) {
        var isSaveRow = false;

        if (data['__created__'] || data['__modified__']) {
            isSaveRow = true;
        }

        return isSaveRow;
    }

    var getActiveTab = function (selectedTab) {
        var initTab = selectedTab.$target.data('initTab');
        var childFrame;

        if (selectedTab.$target.find('[data-frame-type="tab-iframe"]').length > 0) {
            childFrame = selectedTab.$target.find('[data-frame-type="tab-iframe"]')[0].contentWindow;
        }

        if (ax5.util.isNothing(initTab)) {
            initTab = false;
        }

        selectedTab['initTab'] = initTab;
        selectedTab['childFrame'] = childFrame;

        return selectedTab;
    };

    var bindingTarget = function (target, rowItem) {
        var aryBindingTarget = axboot.util.getBindingTargets(target);
        var cmdFocus = '';
        var cmdReadonly = '';

        for (var i = 0; i < aryBindingTarget.length; i++) {
            if (fnObj.hasOwnProperty(aryBindingTarget[i])) {
                cmdFocus = '';

                fnObj[aryBindingTarget[i]].enable();

                if (axboot.util.getRowState(rowItem) == 'I') {
                    fnObj[aryBindingTarget[i]].target.find(':input').attr('readonly', false);
                    fnObj[aryBindingTarget[i]].target.find(':input').attr('disabled', false);
                    
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-readonly="insert"]').attr('readonly', true);
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-disabled="insert"]').attr('disabled', true);

                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-focus]').each(function (index, element) {
                        cmdFocus = $(element).attr('data-ax-cmd-focus');

                        if (cmdFocus.indexOf('add') > -1) {
                            $(element).focus();
                        }
                    });
                } else {
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-readonly="update"]').attr('readonly', true);
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-disabled="update"]').attr('disabled', true);

                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-focus]').each(function (index, element) {
                        cmdFocus = $(element).attr('data-ax-cmd-focus');

                        if (cmdFocus.indexOf('update') > -1) {
                            $(element).focus();
                        }
                    });
                }

                fnObj[aryBindingTarget[i]].target.find('[data-ax-readonly="true"]').attr('readonly', true);
                fnObj[aryBindingTarget[i]].setData(rowItem);
            }
        }
    };

    // axboot.util.resizeSplitLayout($('[data-ax5layout="ax1"]'), ['*', 100]);
    var resizeSplitLayout = function ($target, option) {
        var sizeArray = [];

        if (ax5.util.isArray(option)) {
            sizeArray = option;
        } else if (ax5.util.isNumber(option) || ax5.util.isString(option)) {
            sizeArray.push(option);
        } else {
            return;
        }

        var config = $target.attr('data-config');

        if (config.startsWith('{') && config.endsWith('}')) {
            config = ax5.util.parseJson(config, true);
        }

        if (ax5.util.isObject(config)) {
            var sizeOption = '';

            if (config['orientation'] == 'vertical') {
                sizeOption = 'width';
            } else if (config['orientation'] == 'horizontal') {
                sizeOption = 'height';
            }

            if (sizeOption == 'width' || sizeOption == 'height') {
                var size = '';

                $target.find('[data-split-panel]').each(function (index, element) {
                    if (index < sizeArray.length) {
                        var widthJson = $(element).attr('data-split-panel');

                        size = sizeArray[index];

                        if (ax5.util.isString(size)) {
                            size = '\'' + size + '\'';
                        }

                        $(element).attr('data-split-panel', '{' + sizeOption + ': ' + size + '}');
                    }
                });

                $target.ax5layout();
            }
        }
    };

    var getResponseType = function (data) {
        var responseType = 'data';

        if (!ax5.util.isNothing(data) && data.hasOwnProperty('errorCount') && data.hasOwnProperty('fieldErrors')) {
            responseType = 'validation';
        }

        return responseType;
    };

    var responseResultMsg = function (data) {
        var responseType = axboot.util.getResponseType(data);

        if (responseType == 'validation') {
            if (data.errorCount > 0) {
                var errorMessage = '';
                var inputField = '';

                $.each(data.fieldErrors, function (index, collection) {
                    inputField = collection.field;

                    if (inputField != '') {
                        errorMessage += inputField + ' : ' + collection.message + '\n';
                    } else {
                        errorMessage += collection.message + '\n';
                    }
                });

                axDialog.alert({
                    title : '오류 알림',
                    theme : 'danger',
                    msg   : errorMessage,
                    width : 500
                });
            } else {
                if (!ax5.util.isNothing(data) && !ax5.util.isNothing(data.responseText)) {
                    axToast.push(data.responseText);
                }
            }
        }
    };

    var getNextSortOrder = function (gridObj, sortColumn) {
        var nextSortOrder;

        if (gridObj.getData().length == 0) {
            nextSortOrder = 1;
        } else {
            nextSortOrder = Math.max.apply(Math, gridObj.getData().map(function (o) { return o[sortColumn]; }));

            if (isNaN(nextSortOrder)) {
                nextSortOrder = gridObj.getData().length;
            }

            nextSortOrder += 1;
        }

        return nextSortOrder;
    };

    var camelToUnderscore = function (val) {
        return val.replace(/([A-Z])/g, function ($1) { return '_' + $1.toLowerCase(); });
    };

    return {
        'setFocusPosition'              : setSelectionRange,
        'getFormToParam'                : getFormToParam,
        'getObjectType'                 : getObjectType,
        'getBindingTargets'             : getBindingTargets,
        'getCommandOptionsToAjaxConfig' : getCommandOptionsToAjaxConfig,
        'getRowState'                   : getRowState,
        'isSelectedRow'                 : isSelectedRow,
        'isSaveRow'                     : isSaveRow,
        'getActiveTab'                  : getActiveTab,
        'bindingTarget'                 : bindingTarget,
        'getResponseType'               : getResponseType,
        'resizeSplitLayout'             : resizeSplitLayout,
        'responseResultMsg'             : responseResultMsg,
        'getNextSortOrder'              : getNextSortOrder,
        'camelToUnderscore'             : camelToUnderscore
    }
})();